"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _ContactPoint = _interopRequireDefault(require("./ContactPoint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-array-index-key */
var SectionContactInfo = function ContactInfoComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var items = sliceData.items,
      sectionTitle = sliceData.primary.contact_title;
  return items.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-tier se-tier--relative content-page__contact-info-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "content-page__contact-title"
  }, dataClient.textToMarkdown(sectionTitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-col se-col--12 se-col--6Tablet"
  }, items.map(function (_ref2, idx) {
    var hasDivider = _ref2.contact_divider,
        heading = _ref2.contact_heading,
        type = _ref2.contact_type,
        labelOverride = _ref2.contact_label,
        contactPointContent = _ref2.contact_point,
        body = _ref2.contact_body;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "".concat(type, "-").concat(idx)
    }, hasDivider && /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__contact-hr"
    }), heading.length > 0 && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "content-page__contact-subtitle"
    }, dataClient.textToMarkdown(heading)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "content-page__contact"
    }, /*#__PURE__*/_react["default"].createElement(_ContactPoint["default"], {
      type: type,
      labelOverride: labelOverride,
      contactPointContent: contactPointContent
    }), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      baseClass: "content-page__contact-body",
      content: body
    })));
  })))));
};

SectionContactInfo.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({}).isRequired
};
var _default = SectionContactInfo;
exports["default"] = _default;